import { Layout } from "antd";
import { Outlet } from "react-router-dom";

export const MainLayout: React.FC = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};
